import React from 'react'

const Brand = ({ brand, brand_logo, line }) => {

    return (
        <div className='col-12'>
            {/* <img
                className="float-left"
                src={brand_logo}
                alt={brand}
            /> */}
            <span style={{ fontSize: "15px", fontWeight: "700" }}>{brand}</span>
        </div>
    )
}

export default Brand